import React from "react";
import { TextField, Box } from "@mui/material";
import { useTranslation } from "../../../hooks/useTranslation";

interface PasswordFieldsProps {
  password: string;
  onPasswordChange: (value: string) => void;
  confirmation: string;
  onConfirmationChange: (value: string) => void;
  error?: string | null;
  /**
   * Current password, shown only when the account already has one. Changing a
   * password now requires proving you know the old one, so a live session on a
   * borrowed or stolen device cannot quietly take the account over.
   */
  currentPassword?: string;
  onCurrentPasswordChange?: (value: string) => void;
}

export const PasswordFields: React.FC<PasswordFieldsProps> = ({
  password,
  onPasswordChange,
  confirmation,
  onConfirmationChange,
  error,
  currentPassword,
  onCurrentPasswordChange,
}) => {
  const { p } = useTranslation("workspaceSettings");

  return (
    <Box>
      {onCurrentPasswordChange && (
        <TextField
          type="password"
          label={p("current_password_field_label")}
          value={currentPassword ?? ""}
          onChange={(e) => onCurrentPasswordChange(e.target.value)}
          autoComplete="current-password"
          fullWidth
          margin="normal"
          size="small"
          inputProps={{ "data-testid": "current-password-field-input" }}
        />
      )}
      <TextField
        type="password"
        label={p("password_field_label")}
        value={password}
        onChange={(e) => onPasswordChange(e.target.value)}
        fullWidth
        margin="normal"
        size="small"
        inputProps={{ "data-testid": "password-field-input" }}
      />
      <TextField
        type="password"
        label={p("password_confirmation_field_label")}
        value={confirmation}
        onChange={(e) => onConfirmationChange(e.target.value)}
        fullWidth
        margin="normal"
        size="small"
        error={!!error}
        helperText={error ?? undefined}
        inputProps={{ "data-testid": "password-confirmation-field-input" }}
      />
    </Box>
  );
};
